import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';
import WindowBrowser from "../components/browser-window";

const Engineering = () => {
  useEffect(() => {

  }, [])

  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>Engineering</h1>
        <h3> Spot the Fake. Safeguard the Cure.</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              ENGINEERING
            </div>
            <Scrollspy
               offset={-140}
              className="scrollspy" items={['Engineering_Overview', 'Cycle1', 'Cycle2', 'Cycle3', 'Conclusion']}
              currentClassName="active">
              <li><a href="#Engineering_Overview">Engineering Success & Overview</a></li>
              <li><a href="#Cycle1">Cycle 1</a></li>
              <li><a href="#Cycle2">Cycle 2</a></li>
              <li><a href="#Cycle3">Cycle 3</a></li>
              <li><a href="#Conclusion">Conclusion: Engineering Success</a></li>

            </Scrollspy>
            <img
              src="https://static.igem.wiki/teams/5334/wiki-images/updated-mascot/mascot-reading-book-light-4.webp"
              alt="Mascot is reading a book"

            />
          </div>

        </div>,.,
        <div className="main_lab_style">
          <WindowBrowser description={
            <>
           
              <h1 id="Engineering_Overview">
                Engineering Success & Overview
              </h1>
              <p>

              </p>
              <p>
                BevaTech is dedicated to developing an aptamer-based lateral flow test strip that offers a rapid, affordable, and sensitive point-of-care diagnostic tool. Designed for global distribution and ease of use without requiring specialized expertise, this device aims to enhance accessibility and efficiency in detecting bevacizumab.
              </p>
              <p>
                We employed the Design-Build-Test-Learn (DBTL) cycle, iterating through multiple stages to refine and optimize our platform. This approach was complemented by a human-centered design strategy, ensuring that the development of BevaTech was responsive to user needs and real-world applications. The DBTL cycle has been integral to our project, guiding the evolution of BevaTech to its current final stage.
              </p>
              <p>
                Our journey began with developing the DNA aptamer, specifically designed to bind sensitively to bevacizumab. This aptamer was immobilized onto the lateral flow assay (LFA) membrane. The design phase included comprehensive literature reviews and creativity, followed by the construction of the aptasensor and subsequent evaluations of progress.
              </p>
              <p>
                We engaged with various experts throughout the development process and incorporated their feedback, as detailed on our human practice page. The iterative nature of the DBTL cycle allowed us to continuously improve the aptamer and assay system, culminating in a robust and effective final product.
              </p>
              <br />
              


                <div className="diagram m-4" style={{ marginTop: 50 }}>
                  <div className="row d-flex justify-content-between align-center">
                    <div className="circle floating">
                      DESIGN
                    </div>
                    <div className="triangle">
                      <div class="arrow-right"></div>
                    </div>
                    <div className="circle floating floating2">
                      BUILD
                    </div>
                  </div>
                  <div className="row d-flex justify-content-between align-center">
                    <div class="arrow-up" style={{ marginLeft: 75 }}></div>
                    <div className="text">
                      iGEM
                      <br />
                      Engineering
                      <br /> cycle
                    </div>
                    <div class="arrow-down" style={{ marginRight: 55 }}></div>
                  </div>
                  <div className="row d-flex justify-content-between align-center">
                    <div className="circle floating floating3">
                      LEARN
                    </div>
                    <div className="triangle">
                      <div class="arrow-left"></div>
                    </div>
                    <div className="circle floating floating4">
                      TEST
                    </div>
                  </div>
                </div>


                
                <section id="Cycle1">
                <br />
                <br />


                <h1 >Cycle 1 Aptamers</h1>

                <p >
                  <h1>Design </h1>
                  <strong>Focus</strong>
                </p>
                <p>
                  The primary focus of the design phase is to identify a suitable DNA aptamer sequence that specifically binds to the bevacizumab antibody with high affinity. This aptamer will be the recognition element in a lateral flow assay (LFA) for detecting counterfeit bevacizumab.                  </p>
                <p><strong>Background Research </strong></p>
                <p>
                  Aptamers are single-stranded DNA or RNA molecules that can fold into unique three-dimensional shapes, allowing them to bind specifically to target molecules, such as proteins, small molecules, or even cells. Aptamers are generated through an in vitro selection process called Systematic Evolution of Ligands by Exponential Enrichment (SELEX), which involves iterative rounds of binding, separation, and amplification to isolate sequences with desired binding properties from an extensive random library.
                </p>
                <p>
                  We began by searching the literature for DNA aptamers previously developed against bevacizumab. Our criteria for aptamer selection included high binding affinity, specificity for the antibody's complementarity-determining region (CDR), and feasibility for incorporation into an LFA format. Recent research by Saito et al. has identified several DNA aptamer sequences that bind specifically to the complementarity-determining region (CDR) of the therapeutic monoclonal antibody bevacizumab. The study reported the crystal structure of the aptamer-Fab complex, providing valuable insights into the binding interaction.
                </p>
                <br>
                </br>
                <h1>Build </h1>
                <p><strong> Aptamer Selection</strong></p>
                <p>Among the aptamer sequences reported by Saito et al., the aptamer A14#1
                  <strong>(5′-GCGGTTGGTGGTAGTTACGTTCGC-3′) </strong>
                  was selected for further development in our project. This choice was based on the aptamer's high binding affinity for bevacizumab, with a dissociation constant (KD) of 44 pM under mildly acidic conditions. The
                  <strong> A14#1 </strong>
                  aptamer demonstrated superior binding properties to the other sequences evaluated in the study.
                </p>
                <br>
                </br>

                <p><strong>Aptamer Modeling
                </strong></p>
                <p>
                  <i>Bioinformatics Approach: </i>
                  We used the 3dDNA web server for folding predictions, which provided preliminary structure information for aptamer modeling. This helped us understand potential binding sites and conformational changes.

                </p>
                <p>
                  <i>Docking Approach: </i>
                  To refine our selection, we employed multiple docking platforms:
                  <ul>
                    <li><strong>AutoDock Vina: </strong>For initial binding predictions and scoring.
                    </li>
                    <li><strong>HADDOCK: </strong>To enhance the docking results by incorporating biological and structural knowledge.
                    </li>
                    <li><strong>PatchDock: </strong> This is used to evaluate potential binding modes and interactions.
                    </li>
                  </ul>
                  We analyzed docking scores and introduced mutations to explore improved binding sites, creating and testing six aptamer variants.
                </p>
                <p>
                  <i>Molecular Dynamics: </i>
                  Using GROMACS 2021.1 with the amber14sb_ol21 force field, we performed molecular dynamics simulations to assess the stability of the aptamer variants. Binding affinity was evaluated using MM/PBSA calculations via gmx_MMPBSA software, allowing us to select aptamer CU2#19 based on superior stability and binding characteristics.

                </p>

                <p>
                  We took the aptamer obtained through SELEX and sequentially optimized it using docking and molecular dynamics methods. We generated six variants detailed on the Modeling page and subsequently tested them.
                </p>
                <p>
                  The selected aptamer was modified with a thiol group at the 3′ end to enable conjugation to gold nanoparticles (AuNPs), which serve as the colorimetric reporter in the LFA. The AuNP-aptamer conjugate captures bevacizumab from the sample and generates a visible signal at the test line.
                </p>

                <br>
                </br>
                <h1>Test  </h1>
                <p><i>
                  ELONA and Microscale Thermophoresis
                </i></p>
                <p>
                  The aptamer-based lateral flow assay is tested through Enzyme-Linked Oligonucleotide Assay (ELONA) and Microscale Thermophoresis (MST) to precisely determine the aptamer binding affinity.
                </p>

                <p>
                  Selection of the aptamer with the highest binding affinity from the large pool of active nucleic acid molecules needs to be conducted. Hence, ELONA has been an optimized label-free characterization approach for analyzing the aptamer-target interaction in significant femtomolar range without undergoing laborious and time-consuming processes. ELONA involved the enzyme-linked aptamers' fluorescent readout when interacting with the Bevacizumab target compound, allowing simultaneous analysis of the aptamers. This method is also suitable for colorimetric analysis of DNA aptamers due to its labeling of biotin or digoxigenin. ELONA provides a more sensitive, specific, stable, and versatile characterization for nucleic acids, especially aptamers. The result shows that a clear color change visualization can be quantified.
                </p>

                <p>
                  Further analysis was conducted using the MST, a combination of label-based and label-free techniques based on thermophoresis that evaluate molecule diffusion/movement under temperature influence. Applying a temperature gradient to a solution containing molecules that have been fluorescently tagged causes changes in the molecules’ size, charge, and hydration shell, all of which are impacted by binding events. This method gives a specific and rapid close-to-native and microscale volume analysis of aptamer-target interaction because of its free-in-solution-based analysis.
                </p>
                <p>
                  With both of these methods, we can ensure that our aptamer can accurately detect bevacizumab and minimize the risk of cross-reactivity with other substances, determining the best possible aptamer.
                </p>

                <br>
                </br>
                <h1>Learn  </h1>
                <p>
                  Insights from the test phase led to targeted improvements in aptamer stability and binding specificity. We utilized bioinformatics and structural analysis tools to refine aptamer sequences, aiming to reduce off-target effects and enhance the robustness of the LFA.

                </p>
                <br>
                </br>
                <p><i>
                  Consultation with Prof. Kwok Chun Kit
                </i></p>
                <p>
                  We consulted Prof. Kwok Chun Kit, a professor from the Department of Chemistry at the City University of Hong Kong, who has extensive experience with aptamers. Dr. Kwok aims to uncover central RNA players in stress physiologies and diseases, reveal novel RNA-mediated gene regulations, and develop targeting strategies via chemical, aptamer, and CRISPR approaches for gene expression manipulation and biotechnological applications.
                </p>
                <br>
                </br>
                <p><i>
                  Key Points of Learning
                </i></p>
                <p>
                  Dr. Kwok advised us to test the specificity of our aptamers to bevacizumab rigorously. Given that we are using literature-derived aptamer sequences, this approach is both efficient and promising. Additionally, he recommended outsourcing aptamer synthesis to Chinese companies due to their quick development times and affordability.
                </p>
                <br>
                </br>
                <p><i>
                  Reflections and Follow-Up Actions

                </i></p>
                <p>
                  We will model and synthesize different aptamer variants to identify the best performer. We will also investigate known impurities and test the aptamer in biological liquids to ensure its effectiveness in detecting counterfeit versions. A follow-up meeting with Dr. Kwok may be arranged to receive further expert feedback before synthesizing.                                </p>



                {/* <p><strong>References:</strong></p>
                <p>[1] Ellington, A., & Szostak, J. (1990). In vitro selection of RNA molecules that bind specific ligands. Nature, 346, 818–822. <a href="https://doi.org/10.1038/346818a0">https://doi.org/10.1038/346818a0</a>
                  <br />
                  [2] Saito, T., Shimizu, Y., Tsukakoshi, K., Abe, K., Lee, J., Ueno, K., Asano, R., Jones, B. V., Yamada, T., Nakano, T., Tong, J., Hishiki, A., Hara, K., Hashimoto, H., Sode, K., Toyo'oka, T., Todoroki, K., & Ikebukuro, K. (2022). Development of a DNA aptamer that binds to the complementarity-determining region of therapeutic monoclonal antibody and affinity improvement induced by pH-change for sensitive detection. Biosensors and Bioelectronics, 203, 114027. <a href="https://doi.org/10.1016/j.bios.2022.114027"> https://doi.org/10.1016/j.bios.2022.114027 </a>

                </p>  */}



              </section>



              <section id="Cycle2">
                <br />
                <br />
                <h1>
                  Cycle 2 = LFA
                </h1>

                <h1>Design</h1>

                <h2>
                  Focus
                </h2>
                <p>
                  The focus of this phase is to design a Lateral Flow Assay (LFA) that utilizes the previously developed aptamer to detect Bevacizumab in samples, emphasizing creating a reliable and easy-to-use diagnostic tool.
                </p>

                <h2>
                  Background Research
                </h2>

                <p>
                  Lateral Flow Assays (LFAs) are widely used point-of-care diagnostic tools that allow for rapid, qualitative, or semi-quantitative detection of analytes in various samples. These assays typically consist of a series of pads and membranes arranged on a strip, facilitating the movement of a liquid sample via capillary action.
                </p>

                <h2>
                  Initial Biosensors Design
                </h2>
                <p>
                  At the initial stage of our project, we are looking into multiple applicable biosensors that can easily be distributed to crisis regions. Some initial designs that we considered implementing include microfluidic chips, which we consulted further with Professor Ang Wee Han from the National University of Singapore. Despite interest in microfluidic chips, time constraints made them impractical. Prof. Ang advised optimizing the aptamer and designing the chemistry/assay system, with lateral flow assays ideal for rapid hospital use and potential commercialization.
                </p>

                <h2>Aptamers role in LFA Design
                </h2>
                <p>
                  Aptamers are short single-stranded nucleic acids that bind to specific target molecules with high affinity, making them ideal recognition elements in diagnostic assays. In our LFA, we are using multiple aptamer sequences for different functions, each designed to play a specific role in the assay. The following aptamers have been developed and incorporated into the LFA design:
                </p>

                <ol>
                  <li>
                    <h4>Control Line Aptamer:</h4>
                    <ul>
                      <li>
                        <strong>Sequence:</strong> 5′-Biotin-TTT TTT TTT TTT TTT TTT-3′
                      </li>
                      <li>
                        <strong>Purification:</strong> HPLC
                      </li>
                      <li>
                        <strong>Role:</strong> This aptamer is immobilized on the control line of the nitrocellulose membrane. It binds the AuNP-aptamer conjugate that flows through the strip, confirming that the assay system is functioning properly. The control line serves as an internal quality check, ensuring that the sample has migrated properly across the strip and that the reagents are functional.
                      </li>
                    </ul>
                  </li>

                  <li>
                    <h4>Test Line Aptamer:</h4>
                    <ul>
                      <li>
                        <strong>Sequence:</strong> 5′-Biotin-CGCCAACCACCATCAATGCCAGCG-3′

                      </li>
                      <li>
                        <strong>Purification:</strong> HPLC
                      </li>
                      <li>
                        <strong>Role:</strong>
                        This aptamer is immobilized on the test line and is responsible for binding to Bevacizumab. It competes with the Bevacizumab in the sample for binding to the AuNP-labeled aptamer conjugate. The competitive nature of the binding leads to a visual signal that is inversely proportional to the concentration of Bevacizumab in the sample.
                      </li>
                    </ul>
                  </li>

                  <li>
                    <h4>Sample Pad Aptamer:</h4>
                    <ul>
                      <li>
                        <strong>Sequence:</strong> 5′-GCG GTT GGT GGT AGT TAC GGT CGC AAA AAA AAA AAA AAA AAA-SH-3′

                      </li>
                      <li>
                        <strong>Purification:</strong> HPLC
                      </li>
                      <li>
                        <strong>Role:</strong>
                        This aptamer is present in the sample pad, helping to precondition and stabilize the sample as it enters the assay system, ensuring efficient binding interactions with Bevacizumab.                        </li>
                    </ul>
                  </li>
                </ol>

                <p>
                  These aptamers are carefully purified using HPLC to ensure that they maintain high specificity and affinity for Bevacizumab, contributing to the overall reliability and sensitivity of the LFA.
                </p>

                <h2>
                  Lateral Flow Assay (LFA) Design
                </h2>
                <p>
                  Next, we designed the LFA strip architecture and selected the component materials. The strip consists of a sample pad, where the liquid sample is applied; a conjugate pad, which contains the AuNP-aptamer conjugate; a nitrocellulose membrane, which houses the test and control lines; and an absorbent pad, which drives the capillary flow and collects the excess liquid.
                </p>
                <img src="https://static.igem.wiki/teams/5334/wiki-images/lab/ve-hardware-and-schematic.webp">
                </img>

                

                <p>
                  The test line comprises the same aptamer sequence immobilized on the membrane, while the control line contains an immobilized complementary oligo that captures any excess AuNP-aptamer conjugate.
                </p>
                <p>
                  When a sample containing bevacizumab is applied to the strip, it flows laterally across the membrane by capillary action. As the sample reaches the conjugate pad, the bevacizumab competes with the AuNP-aptamer conjugate for binding to the immobilized bevacizumab at the test line.
                </p>
                <p>
                  In this competitive format, the presence of bevacizumab in the sample reduces the amount of AuNP-aptamer conjugate that binds to the test line, resulting in a less intense red-colored band at the test line. The intensity of the test line is inversely proportional to the concentration of bevacizumab in the sample. Any unbound AuNP-aptamer conjugate is captured at the control line, generating a second red band that confirms proper sample flow and reagent functionality.
                </p>
                <p><i>
                  Results Interpretation:
                </i></p>

                <ul>
                  <li>
                    <strong>One Line (Control Line only): </strong>Indicates that bevacizumab is present in the sample. The test line is not visible because the analyte from the sample effectively competes with the labeled form, preventing it from binding to the test line.
                  </li>
                  <li>
                    <strong>Two Lines (Control Line and Test Line): </strong>Indicates that bevacizumab is absent or present in insufficient amounts to compete. Both lines are visible because the gold nanoparticles bind to the test line.
                  </li>
                </ul>


                {/* <h2> References: </h2>

                <ol>
                  <li>
                    Ellington A & Szostak J (1990) In vitro selection of RNA molecules that bind specific ligands. Nature 346, 818–822.                  </li>
                  <li>
                    Saito T et al. (2022) Development of a DNA aptamer that binds to the complementarity-determining region of therapeutic monoclonal antibody and affinity improvement induced by pH-change for sensitive detection. Biosens. Bioelectron. 203, 114027.
                  </li>
                  <li>
                    Ahirwar R, Nahar S, Aggarwal S et al. (2016) In silico selection of an aptamer to estrogen receptor alpha using computational docking employing estrogen response elements as aptamer-alike molecules. Sci. Rep. 6, 21285.
                  </li>

                </ol> */}


                <h1>
                  Build
                </h1>
                <p>
                  The construction of the LFA involves several critical steps to ensure that each component functions correctly and that the assay delivers reliable results. Key steps include:
                </p>
                <ul>
                  <li>
                    <strong>AuNP Synthesis and Conjugation:</strong> Synthesize gold nanoparticles (AuNPs) with different diameteres (20-50 nm) and conjugate them with the aptamer, ensuring the correct aptamer-to-AuNP ratio for stability and functionality.
                  </li>
                  <li>
                    <strong>Strip Assembly:</strong> Carefully assemble the sample pad, conjugate pad, nitrocellulose membrane, and absorbent pad on a backing card. Ensure proper alignment to facilitate capillary flow.
                  </li>
                  <li>
                    <strong>Reagent Dispensing:</strong> Dispense the aptamer and control oligos onto the nitrocellulose membrane to create the test and control lines. Optimize dispensing parameters for uniformity and reproducibility.
                  </li>

                </ul>

                <h1>
                  Test
                </h1>
                <p>
                  Assay Validation: After constructing the LFA strips, they undergo rigorous testing to validate their performance:
                </p>
                <ul>
                  <li>
                    <strong>Sample Testing: </strong>
                    Apply samples containing known concentrations of bevacizumab to the LFA strips and observe the appearance and intensity of the test and control lines.
                  </li>
                  <li>
                    <strong>Signal Intensity and Consistency: </strong>
                    Measure the signal intensity across multiple strips to ensure consistency and reproducibility. Evaluate the impact of different materials on the flow rate, background noise, and signal-to-noise ratio.                  </li>
                  <li>
                    <strong>Stability Testing: </strong>
                    Assess the stability of the AuNP-aptamer conjugate over time and under various storage conditions to ensure the long-term reliability of the assay.
                  </li>

                </ul>

                <h1>
                  Learn
                </h1>
                <p>
                  During the development of the LFA, we encountered several technical challenges related to the stability and reproducibility of the assay components. The initial batches of AuNP-aptamer conjugates tended to aggregate and precipitate, leading to poor performance and inconsistent results. We addressed this issue by optimizing the AuNP synthesis protocol to produce more uniform and monodisperse particles and carefully titrating the aptamer-to-AuNP ratio to ensure a stable and functional conjugate.
                </p>
                <p>
                  Another challenge was the signal intensity of the LFA strips. We found that the choice of nitrocellulose membrane, sample pad, conjugate pad, and absorbent pad materials significantly impacted the assay performance. We screened multiple membrane types to identify the optimal combination that provided consistent flow rates, low background, and high signal-to-noise ratios. We also optimized the dispensing parameters for the test and control line reagents to achieve reproducible and uniform signal intensities. The materials and dimensions used in the LFA test strips were carefully selected based on their properties and compatibility with the assay requirements.
                </p>

                <p><i>
                  Consultation with Prof. Ang Wee Han
                </i></p>
                <p>
                  We consulted Prof. Ang Wee Han from the Department of Chemistry at the National University of Singapore. Prof. Ang’s research focuses on developing therapeutic metallopharmaceuticals and techniques to investigate interactions of transition metal-based drugs with biological targets.
                </p>

                <p><i>
                  Key Points of Learning
                </i></p>

                <p>
                  Prof. Ang’s research includes developing biosensors using lateral flow assays. His advice on materials, mechanisms, processes, and timelines for biosensor development was precious. He suggested expanding our project to explore other biologics used in immunotherapy and antibody treatments. He emphasized the importance of aptamer accuracy in biosensors and recommended using sandwich ELISA for tests, despite its cost and time demands. Although we were interested in his work with microfluidic chips, the process may be too time-consuming. Prof. Ang advised optimizing the aptamer and designing the chemistry/assay system. He noted that lateral flow assays are ideal for quick hospital use and future commercialization.
                </p>

                <p><i>Reflections and Follow-Up Actions
                </i></p>
                <p>
                  We will focus on optimizing the specificity of the aptamers using ELISA. We will also conduct more literature reviews to find additional assay systems that could accurately test aptamer binding affinity. Following Prof. Ang’s suggestion, we will use a lateral flow assay for our device.
                </p>
                <p><i>Consideration of LFA format
                </i></p>
                <ul>
                  <li>
                    Competitive Binding LFA is typically more sensitive and can detect lower concentrations of analytes by measuring the competition between the target analyte and a labeled analog. It is suitable for cases where high sensitivity is required.
                  </li>
                  <li>
                    Conventional Sandwich LFA is more straightforward and often used for detecting higher concentrations of analytes. It provides straightforward results and is widely applicable but might not be as sensitive as competitive binding assays.
                  </li>

                </ul>



                <div className="diagram m-4" style={{ marginTop: 50, marginBottom: 100 }}>
                  <div className="row d-flex">
                    <div className="romb">
                      <div className="circle ">
                        BUILD
                      </div>
                      <div className="circle ">
                        TEST
                      </div>
                    </div>
                    <div className="text">
                      iGEM
                      <br />
                      Engineering
                      <br /> cycle
                    </div>
                    <div className="oval">

                    </div>
                    <div className="romb">
                      <div className="circle ">
                        LEARN
                      </div>
                      <div className="circle ">
                        DESIGN
                      </div>
                    </div>

                  </div>

                </div>
                

              </section>


              <section id="Cycle3">
              <br />
              <br />
              <h1>Cycle 3 = Optimization
                </h1>
                <h2>
                  Focus
                </h2>
                <p>
                  Since the previous two cycles have already allowed us to develop a functional test system by optimizing all processes, this cycle focuses on potential modifications to the final form of the rapid test that will make it optimal for industrial production.And this, in turn, is related to maximizing cost reduction in production without compromising quality or sensitivity to counterfeit bevacizumab.
                </p>

                <h1>
                  Design
                </h1>
                <ol>
                  <li>
                    Optimization of aptamer concentration :  Conducting series of experiments to determine the minimal aptamer concentration capable of binding the desired amount of bevacizumab. Utilize ELONA assays and leverage binding constants from previous MST experiments to estimate concentration ranges for testing. This requires switching to chemiluminescence detection as it allows work in a smaller range of concentrations.
                  </li>
                  <li>
                    Gold Nanoparticle (Au-NP) parameter tuning: Design variations in Au-NP size and surface modifications to enhance aptamer binding efficiency. Explore changes in nanoparticle surface functionalization to optimize the interaction between the aptamer and Au-NP.
                  </li>
                  <li>
                    Optimization of test strip length: Plan a reduction in the length of the test strip to minimize the quantity of membrane material used. Ensure that the strip remains functional while reducing production costs without compromising sensitivity or specificity.
                  </li>

                </ol>

                <h1>
                  Build
                </h1>

                <ol>
                  <li>
                    Aptamer concentration testing: Prepare different test strips with varying aptamer concentrations based on initial MST data. Incorporate the selected aptamer onto the strips and prepare them for ELONA testing.                  </li>
                  <li>
                    Au-NP parameter variations: Construct LFA strips with modified Au-NPs, varying size and surface functionalization. Test these strips in binding assays to observe differences in signal intensity and efficiency.                  </li>
                  <li>
                    Test strip length prototypes: Build multiple test strips with varying lengths, ensuring that the shorter strips maintain the functional zones (sample pad, conjugate pad, test line, and control line) necessary for accurate detection.                  </li>

                </ol>

                <h1>
                  Test
                </h1>
                <ol>
                  <li>
                    Aptamer concentration: Test the minimal aptamer concentration using ELONA assays, comparing the detection efficiency across a concentration gradient. Use MST-derived binding constants to validate results.
                  </li>
                  <li>
                    Au-NP efficiency: Test the newly constructed LFA strips with modified Au-NPs to evaluate their binding performance, signal strength, and overall sensitivity.
                  </li>
                  <li>
                    Test strip length: Test the performance of the shortened test strips, ensuring that signal strength and the ability to detect bevacizumab remain consistent despite the reduction in membrane use.

                  </li>
                </ol>


                <h1>
                  Learn
                </h1>
                <ol>
                  <li>
                    Aptamer concentration insights: Analyze the results to determine the minimal aptamer concentration that can reliably detect the target concentration of bevacizumab. Adjust future strips to use this optimal concentration.
                  </li>
                  <li>
                    Au-NP optimization: Learn which Au-NP parameters (size, surface modifications) result in the most efficient binding and signal amplification. Incorporate these findings into future strip designs.
                  </li>
                  <li>
                    Cost and material optimization: Assess whether shorter strips maintain performance while reducing material use, and estimate the cost savings from reduced membrane material. Incorporate these designs into the final prototype if effective
                  </li>
                </ol>

              </section>

              <section id="Conclusion">
                <br />
                <br />
                <h1>
                Conclusion: Engineering Success
                </h1>
                <p>
                BevaTech has successfully developed an innovative aptamer-based lateral flow test strip that stands to revolutionize point-of-care diagnostics for bevacizumab. Our commitment to creating a rapid, affordable, and user-friendly tool reflects a deep understanding of the needs within the healthcare landscape. By employing the Design-Build-Test-Learn (DBTL) cycle, we have not only refined our technology but also ensured that it is aligned with user requirements and practical applications.
                </p>
                <p>
                The meticulous development of our DNA aptamer and LFA, as well as the incorporation of expert feedback throughout the project, have been pivotal in creating a sensitive and reliable assay system. This collaborative and iterative approach has enabled us to overcome challenges and enhance the efficacy of our product. As we move forward, BevaTech is poised to make significant contributions to global health by improving accessibility and efficiency in diagnostic testing, ultimately leading to better patient outcomes.
                </p>
                <p>
                We look forward to the next steps in our journey and are excited about the impact BevaTech will have in the field of diagnostics.
                </p>
              </section>

              <br />
              <br />
            </>
          } />


        </div>
      </section>
    </div>
  );
}

export default Engineering;


